import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import firebase from "firebase";


import {
  LOAD_FOLDER_LIST, DELETE_FOLDER
} from "constants/ActionTypes";

import {
  loadFolderListSuccess, deleteFolder
} from "../actions/MyFolders";


export function* deleteFolderById() {
  yield takeEvery(DELETE_FOLDER, deleteFolderFromID);
}

function* deleteFolderFromID({ payload }) {

  const { userId, key } = payload;
  const projectID = localStorage.getItem("project_id");

  var foldersRef = firebase.database().ref('/folder_list/' + userId + '/' + projectID + '/' + key);
  foldersRef.remove();

}



export function* loadMyFolders() {
  yield takeEvery(LOAD_FOLDER_LIST, loadFolderByID);
}

function* loadFolderByID({ payload }) {
  console.log("*************  sono nel sagas load folders");
  const { userID, projectID } = payload;

  try {

    var myUserID= localStorage.getItem('user_id');
    var myProjectID= localStorage.getItem('project_id');
    console.log("************* userID "+myUserID);
    
    console.log("************* projectID "+myProjectID);

    var foldersRef = firebase.database().ref('/folder_list/' + myUserID + '/' + myProjectID)
    var folders = yield call(function () {
      return new Promise(function (resolve, reject) {
        foldersRef.once('value', function (snap) {

          var folders = snap;
          
          resolve(folders)
        })
      })
    })
    yield put(loadFolderListSuccess(folders))

  } catch (error) {

  }

}

export default function* rootSaga() {
  yield all([fork(loadMyFolders),
  fork(deleteFolderById),
  ]);
}

